import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import CheckoutPage from "./components/checkout/CheckoutPage";
import { CheckoutProvider, useCheckout } from "./context/CheckoutContext";
import { LanguageProvider } from "./context/LanguageContext";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import { fetchAndUpdateMetadata } from "./utils/metadataUtils";
import AltruonCheckoutPage from "./components/checkout/AltruonCheckoutPage";
import AddPaymentSourcePage from "./components/checkout/AddPaymentSourcePage";
import { useStyles } from "./context/StyleContext";

// Resolves tenant branding from the domain alone (independent of whichever
// specific checkout session/config later succeeds or fails) and seeds it into
// context as a baseline. A more specific fetch elsewhere overwrites it once
// it resolves; if that fetch fails instead, this baseline is what error pages
// fall back to instead of a generic "the merchant" placeholder.
function MetadataBootstrap() {
  const { setMerchantName, setLogoUrl } = useCheckout();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const merchantData = await fetchAndUpdateMetadata();
      if (cancelled || !merchantData) return;
      if (merchantData.companyName) setMerchantName(merchantData.companyName);
      if (merchantData.logoUrl) setLogoUrl(merchantData.logoUrl);
    })();
    return () => {
      cancelled = true;
    };
  }, [setMerchantName, setLogoUrl]);

  return null;
}

function AppContent() {
  const { styles } = useStyles();

  return (
    <>
      <LanguageProvider>
        <CheckoutProvider>
          <MetadataBootstrap />
          <div
            className="App"
            style={{
              backgroundColor: styles?.colors?.pageBackground || '#ffffff',
              fontFamily: styles?.typography?.fontFamily || 'Arial, sans-serif'
            }}
          >
            <Router>
              <div className="App-content">
                <Routes>
                  <Route
                    path="/checkout/hosted_pages/checkout"
                    element={<CheckoutPage />}
                  />
                  <Route path="/checkout/s/:sessionId" element={<CheckoutPage />} />
                  <Route path="/checkout/a/:sessionId" element={<AddPaymentSourcePage />} />
                  <Route path="/checkout/p/:configId" element={<CheckoutPage />} />
                  <Route path="/checkout/:shortKey" element={<CheckoutPage />} />
                  <Route path="/checkout" element={<CheckoutPage />} />
                  <Route path="/altruon-checkout" element={<AltruonCheckoutPage />} />
                </Routes>
              </div>
            </Router>
          </div>
        </CheckoutProvider>
      </LanguageProvider>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored" // Optional: light, dark, colored
      />
    </>
  );
}

function App() {
  return <AppContent />;
}

export default App;
